import MultiSelectFilterField from './MultiSelectFilterField';
export default MultiSelectFilterField;
